module.exports = __webpack_public_path__ + "static/media/loser.43015189.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loser.png
// module id = 399
// module chunks = 0